import {TEffect, type Effect} from '@packages/systems/plugins/Effect';
import {Plugins} from '@packages/systems/wfdl';
import {
  functionOf,
  TTypeReference,
  TTypeConstructor,
  TTypeApplication,
} from '@packages/systems/wfdl-ast';
import {forall} from '@packages/utilities/wfdl-helpers';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import type {FormDataType} from './types';
import {formDataFieldsType} from './formDataFieldsType';

// @ts-expect-error - TS2314 - Generic type 'Effect' requires 3 type argument(s).
type FormTriggerValue = <IO, Value>(arg1: FormDataType) => Effect<IO, Value>;

export const formTriggerValue = {
  formTrigger: {
    envType: {
      dataType: forall(
        ['error', 'a'],
        functionOf(
          TTypeApplication({
            con: TTypeApplication({
              con: TTypeConstructor(
                qualify(Plugins.name('Logic'), typeName('FormParser'))
              ),
              arg: TTypeReference('error'),
            }),
            arg: TTypeReference('a'),
          }),
          functionOf(
            formDataFieldsType,
            TEffect(TTypeReference('error'), TTypeReference('a'))
          )
        )
      ),
      exported: 'hidden',
    },
    value: (fn: FormTriggerValue): FormTriggerValue => fn,
  },
} as const;
